import { Link } from "react-router-dom";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";

function ActionCell({ serviceId }) {
  return (
    <Link to={`/iaas/server/detail/${serviceId}`}>
      <SoftButton variant="outlined" color="info" size="small">
        Details
      </SoftButton>
    </Link>
  );
}

// PropTypes-Validierung
ActionCell.propTypes = {
  serviceId: PropTypes.string,
};

export default ActionCell;